/**
 * ClientLayout
 *
 * Minimal chrome for the client portal -- product identity, project
 * name(s), sign out. Deliberately NOT the admin <Layout> (no People/
 * Companies/Projects/Settings nav) -- a client must never be one click from
 * an admin screen, or even see that admin screens exist.
 * See project-brain/pages/client-outcomes.md "Layout".
 */

import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useClientAuth } from '@contexts/ClientAuthContext';
import bbhLogoUrl from '@/assets/bbh-logo.svg';
import './ClientLayout.css';

const ClientLayout: React.FC = () => {
  const { person, logout } = useClientAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await logout();
    navigate('/client/login', { replace: true });
  };

  return (
    <div className="client-layout">
      <header className="client-layout-header">
        <div className="client-layout-brand">
          <img className="client-layout-logo" src={bbhLogoUrl} alt="Backed by Humans" />
          {person && person.linked_project_names.length > 0 && (
            <span className="client-layout-project-names">
              {person.linked_project_names.join(', ')}
            </span>
          )}
        </div>
        <button className="client-layout-signout" onClick={handleSignOut}>
          Sign out
        </button>
      </header>
      <main className="client-layout-content">
        <Outlet />
      </main>
    </div>
  );
};

export default ClientLayout;
